import { memo } from 'react';

import type { SVGProps } from 'react';
const SvgIconLogoLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 131 135"
    role="img"
    className={props.className}
    {...props}
  >
    <path
      fill="#9BF4EF"
      d="M66.346 32.39a1.104 1.104 0 0 0-1.335.016L1.781 81.633A1.104 1.104 0 0 1 0 80.763V49.669c0-.348.164-.675.443-.884L65.002.502a1.104 1.104 0 0 1 1.334.009l62.203 47.87c.578.445.573 1.319-.011 1.757L110.226 63.87a1.1 1.1 0 0 1-1.319.005z"
    />
    <path
      fill="#9BF4EF"
      d="M64.451 102.611c.398.294.944.288 1.335-.017l63.229-49.227a1.104 1.104 0 0 1 1.782.87v31.094c0 .348-.164.675-.443.884l-64.559 48.283a1.1 1.1 0 0 1-1.334-.009L2.258 86.619a1.104 1.104 0 0 1 .011-1.757L20.571 71.13c.39-.293.927-.295 1.32-.005z"
    />
  </svg>
);
const Memo = memo(SvgIconLogoLight);
export default Memo;
